// Base class for cursor manager that defines the public API
class CursorManagerBase {
  destroy() {}
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  sendCursor(point) {}
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  showCursorName(cursorId) {}
}

export default CursorManagerBase;
